import { IObjectsPool } from './interfaces';
import * as utils from '../common/utils';

// Note: the order here affects the order of picked objects menu
export enum ObjectType {
  None = '',
  Ruler = 'ruler',
  Track = 'track',
  SensorTrack = 'sensor-track',
  AngularTrack = 'angular-track',
  Plot = 'plot',
  Sensor = 'sensor',
  FreeDrawing = 'free-drawing',
  TempDrawing = 'temp-drawing',
  AlertPolygon = 'alert-polygon',
  AcousticVector = 'acoustic-vector'
}

export interface AspObjectSubscriber {
  onDataChange(): void;
  onHooked(hooked: boolean): void;
  onTrailVisibility(visible: boolean): void;
}

export abstract class AspObject {

  public geometry: any = null;
  heading: number = 0;
  speed: number = 0;
  vertSpeed: number = 0; // vertical speed
  slotNumber: number; // for objects that are managed in slots
  trailVisible: boolean = false;

  protected isActive: boolean = true;
  private subscribers: Array<AspObjectSubscriber> = new Array();

  constructor(protected _objectsPool: IObjectsPool, public _objectType: ObjectType, public id) {
  }

  static generateId(objectType: ObjectType, id1?: any, id2?: any): string {
    let ident: string;
    if (id1 && id2)
      ident = `${id1}/${id2}`;
    else if (id1)
      ident = `${id1}`;
    else
      ident = `${utils.generateUuid()}`;
    let id: string = `${objectType} ${ident}`;
    return id;
  }

  public active() {
    return this.isActive;
  }

  public activate() {
    this.isActive = true;
  }

  public deactivate() {
    this.isActive = false;
  }

  public get objectsPool() {
    return this._objectsPool;
  }

  public get objectType() {
    return this._objectType;
  }

  protected updateDynamics(x, y, z, hdg = 0, spd = 0, vz = 0) {
    if (this.geometry == null)
      this.geometry = new NeWMI.Geometry.Point();

    this.geometry.x = x;
    this.geometry.y = y;
    this.geometry.z = z;
    this.speed = spd;
    this.heading = hdg;
    this.vertSpeed = vz;
  }

  // Handle incoming message
  abstract handleMsg(msgObj: any): void;

  // Get object searchable identifiers (to be used by Search function)
  getIdentifiers(): string[] {
    return [];
  }

  // Set object hooked/unhooked
  setHooked(hooked) {
    for (let i = 0; i < this.subscribers.length; i++)
      this.subscribers[i].onHooked(hooked);
  }

  isTrailVisible() {
    return this.trailVisible;
  }

  setTrailVisibility(visible: boolean) {
    this.trailVisible = visible;
    for (let i = 0; i < this.subscribers.length; i++)
      this.subscribers[i].onTrailVisibility(visible);
  }

  // Get object title
  abstract getTitle(): string;

  // Get object's main color
  getColor() {
    return [1, 1, 1];
  }

  // color for css html 
  getCssColor() {
    return ""
  }

  // gets the svg icon name
  getSymbol() {
    return "";
  }

  // gets full path and the icon
  getSvgSymbol() {
    return "";
  }

  isValid() {
    return true;
  }

  addSubscriber(subs: AspObjectSubscriber) {
    const index = this.subscribers.indexOf(subs);
    if (index == -1)
      this.subscribers.push(subs);
  }

  delSubscriber(subs: AspObjectSubscriber) {
    const index = this.subscribers.indexOf(subs);
    if (index > -1)
      this.subscribers.splice(index, 1);
  }

  notifyDataChange(): void {
    for (let i = 0; i < this.subscribers.length; i++)
      this.subscribers[i].onDataChange();
  }



}

export class AspObjectsSlot {
  objects: Array<AspObject> = new Array();
  time: number = 0;
}
